import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { Constants } from "@app/constants/constants";
import { MethodsHelper } from "@app/helpers/methods.helper";
import { Branch } from "@app/models/branch";
import { GuaranteeAgreement } from "@app/models/guarantee-agreement";
import { AuthenticationService } from "@app/services/authentication.service";
import { BranchService } from "@app/services/branch.service";
import { GuaranteeService } from "@app/services/guarantee.service";
import { NotificationService } from "@app/services/notification.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-guarantee-disbursement-popup',
    templateUrl: './guarantee-disbursement-popup.component.html',
    styleUrls: ['./guarantee-disbursement-popup.component.css'],
    standalone: false
})

export class GuaranteeDisbursementPopupComponent implements OnInit, OnChanges {

    @Input() displayDialog: boolean;
    @Input() guaranteeAgreement: GuaranteeAgreement;
    @Output() onSubmit = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() disbursementReload = new EventEmitter();

    @ViewChild('form') form: any;

    guaranteeDisbursement: any;

    submittedForm: boolean = false;

    validationMessages: object;

    pageIndex = 0;
    pageSize = Constants.PAGE_ITEM_COUNT;
    totalElements: number;

    defaultPageParams = {
        size: 10,
        page: 0
    }

    yearRange: string;

    branchCodeList: Array<Branch>;

    constructor(
        private notificationService: NotificationService,
        private branchService: BranchService,
        private authenticationService: AuthenticationService,
        private guaranteeService: GuaranteeService,
        private datePipe: DatePipe,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        if (!this.guaranteeDisbursement) {
            this.guaranteeDisbursement = new Object();
            this.guaranteeDisbursement.documentNumber = MethodsHelper.randomString(10);
            this.guaranteeDisbursement.guaranteeAgreementNumber = this.guaranteeAgreement?.guaranteeAgreementNumber;
            this.guaranteeDisbursement.date = this.datePipe.transform(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date(), 'dd-MM-yyyy');
            this.guaranteeDisbursement.amount = this.guaranteeAgreement?.amount;
            this.guaranteeDisbursement.channelCode = Constants.CHANNEL.CHANNEL_CODE;
            this.guaranteeDisbursement.currency = this.guaranteeAgreement?.currency;
            this.guaranteeDisbursement.description = this.guaranteeAgreement?.description;
            this.guaranteeDisbursement.initiatedUserId = this.authenticationService.getCurrentUserId();
            this.guaranteeDisbursement.branchId = this.guaranteeAgreement?.branchId;
            this.guaranteeDisbursement.customerSpecificOptions = this.guaranteeAgreement?.customerSpecificOptions;
            this.guaranteeDisbursement.purpose = this.guaranteeAgreement?.guaranteeAgreementNumber + ' ' + 'guarantee disbursement';
        }
        this.validationMessages = new Object();
        this.yearRange = MethodsHelper.getYearRange(0);
        this.getBranches();
    }

    ngOnChanges() {
        this.getDisbursementInfo();
    }

    getDisbursementInfo() {
        this.guaranteeService.getDisbursementInfo(this.guaranteeAgreement.id).subscribe({
            next: (data) => {
                this.guaranteeDisbursement.documentNumber = data.documentNumber;
                this.guaranteeDisbursement.guaranteeAgreementNumber = data.agreementNumber;
                this.guaranteeDisbursement.date = data.date;
                this.guaranteeDisbursement.amount = data.amount;
                this.guaranteeDisbursement.currency = data.currency;
                this.guaranteeDisbursement.branchId = data.branchId;
                this.guaranteeDisbursement.purpose = data.purpose;
            },
            error: (err) => {
                let msg = MethodsHelper.showErrorMessageStyling(err);
                this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                    "");
            }
        });
    }

    getBranches() {
        const pageOption = {
            size: 10000,
            page: 0
        }
        const pageParams = { ...this.defaultPageParams, ...pageOption };
        this.branchService.getList(pageParams).subscribe(data => {
            this.branchCodeList = data.content;
            this.branchCodeList.forEach(code => {
                this.guaranteeDisbursement.branchId = JSON.parse(this.authenticationService.getUserRoles())[0]?.userBranchId;
            })
        });
    }

    onSave() {
        this.submittedForm = true;
        if (this.validateForm()) {
            let submittingData = this.guaranteeDisbursement;
            this.guaranteeService.disburse(this.guaranteeAgreement.id, submittingData).subscribe({
                next: (data) => {
                    this.notificationService.showHTMLMessage("<i class='fa fa-check-circle' style='line-height: 2'></i> <p>" + `Successfully disbursed.` + "</p>", "");
                    this.cancel();
                    this.disbursementReload.emit();
                },
                error: (err) => {
                    let msg = MethodsHelper.showErrorMessageStyling(err);
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                        "");
                }
            });

        } else {
            this.notificationService.showErrorMessage(this.translate.instant('error.something_incorrect'))}
    }

    validateForm() {
        for (let key in this.validationMessages) {
            if (this.validationMessages[key]) {
                return false;
            }
        }
        if (this.form.form) {
            return this.form.form.valid
        }
        return false;
    }

    cancel() {
        this.onCancel.emit();
    }

    changeBranch(value) {
        if (this.branchCodeList) {
            for (const element of this.branchCodeList) {
                if (element.id == value) {
                    this.guaranteeDisbursement.branchId = element.id;
                    break;
                }
            }
        }
    }

    onAmountFocusOut(event) {
        this.guaranteeDisbursement.amount = MethodsHelper.amountFieldFocusOut(event);
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    }

}
